import requestv2 from "~/utils/http-v2";

const commentApi = {
	gets : async (type, params) => {
		const url = `v2/comment/${type}/${params.id}`;
		return await requestv2.get(url, {params});
	},
	uploadWebsite : async (params) => {
		const url = `v2/comment/upload-website/${params.id}`;
		return await requestv2.get(url, params);
	},
	buyService : async (params) => {
		const url = `v2/comment/buy-service/${params.id}`;
		return await requestv2.get(url, {params});
	},
	add : async (params) => {
		const url = `v2/comment/${params.id}`;
		return await requestv2.post(url, params);
	},
	fileUpload : async (params) => {
		const url = `v2/comment/file/upload`;
		return await requestv2.post(url, params, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
	},
};

export default commentApi;